// extracted by mini-css-extract-plugin
export var hero = "HeroHeaderTagsListSection-module--hero--5a0ce";